import { render } from "./BarraProgresso.vue?vue&type=template&id=c2682136&scoped=true"
import script from "./BarraProgresso.vue?vue&type=script&lang=js"
export * from "./BarraProgresso.vue?vue&type=script&lang=js"

import "./BarraProgresso.vue?vue&type=style&index=0&id=c2682136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2682136"]])

export default __exports__